import React, { useEffect, useState, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getReportTemplateParameter,
  createNewReport,
  updateReport,
  getUpdatedCustomerReportData,
  resetBookingData,
  updateNiptDob,
  createNiptDob,
} from "../../../actions/LimsAdminActions";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import logo from "../../../../redcliffe_logo.jpeg";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import qcCode from "../../../../qrcode.png";
import iso from "../../../../iso.png";
import browserIcon from "../../../../browsericon.png";
import ReactToPrint from "react-to-print";
import gene1 from "../../../../images/gene.svg";
import variant from "../../../../images/variant.svg";
import zygosity from "../../../../images/zygosity.svg";
import location from "../../../../images/location.svg";
import disorder from "../../../../images/disorder.svg";
import inheritance from "../../../../images/inheritance.svg";
import acmg1 from "../../../../images/acmg.svg";
import { useNavigate } from 'react-router-dom';
import Loader from "../../../components/loader/index";
import family from "../../../../images/family.svg";
import brcaresult from "../../../../images/brcaresult.svg";
import { Select, MenuItem, TextField } from '@material-ui/core';
import QRCode from "react-qr-code";
import moment from "moment";
import testLogo from "./Asset 2.png";
import designLogo from "./Asset6.png";
import headerLogo from "./Asset3.png";
import "./brcaReport.css";
import { time } from "console";
import { fontWeight } from "@mui/system";
import Grid from '@mui/material/Grid';
import { Paper } from "@mui/material";
import NpsRating from "../../NPS";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
const useStyles = makeStyles((theme) =>
  createStyles({
    paper: {
      width: "100%",
    },
    centerIt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    fontWeight: {
      fontWeight: "bold",
    },
    textCenter: {
      textAlign: "center",
    },
    endIt: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    },
    belowIt: {
      display: "flex",
      alignItems: "flex-end",
    },
    line: {
      borderBottom: "5px solid red",
      marginTop: "5px",
      width: "90%",
    },
    inputFiled: {
      outline: "none",
    },
    input: {
      padding: "1px",
      direction: "rtl",
    },
    tableBody: {
      maxHeight: 70,
      overflowY: "auto",
    },
    tableCell: {
      padding: 2,
      height: 40,
    },

  })
);
interface Props {
  reportListParameter: any;
  getReportTemplateParameter: any;
  bookingId: any;
  reportData: any;
  createNewReport: any;
  updateReport: any;
  getUpdatedCustomerReportData: any;
  loading: boolean;
  resetBookingData: any;
  updateNiptDob: any;
  createNiptDob: any;
}
const NbsReport: React.FC<Props> = ({
  getReportTemplateParameter,
  reportListParameter,
  bookingId,
  reportData,
  createNewReport,
  updateReport,
  getUpdatedCustomerReportData,
  loading,
  resetBookingData,
  updateNiptDob,
  createNiptDob,
}) => {
  const componentRef = useRef<any>(null);
  const classes = useStyles();
  const navigate = useNavigate();
  const { firstP, secondP, thirdP } = useParams<any>();
  const [status, setStatus] = useState<string>(reportListParameter?.status);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [dob, setDob] = useState<any>("");
  const [age, setAge] = useState<any>("");
  const [Sample_Received, setSample_Received] = useState<any>("");
  const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
  const [Sample_Collected, setSample_Collected] = useState<any>("");
  const [designation, setdesignation] = useState<any>("");
  const [Name, setName] = useState<any>("");
  const [Gender, setGender] = useState<any>("");
  const [uuid, setUuid] = useState();
  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const reactToPrintTrigger = React.useCallback(() => {
    return <button style={{ marginLeft: "10px", background: "#b02613", color: "white" }}>Print Report</button>;
  }, []);

  //booking data
  const [brcaReport, setBrcaReport] = useState<any>([])
  useEffect(() => {
    const data: any = []
    if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
      reportListParameter?.booking?.map((list: any) => {
        data?.push({ ...list });
      })
    }
    setBrcaReport(data);
  }, [reportListParameter])
  useEffect(() => {
    setSample_Collected(brcaReport[0]?.collection_date);
    setSample_Receivedtime(brcaReport[0]?.pickup_time);
    setdesignation(brcaReport[0]?.designation);
    setGender(brcaReport[0]?.customer_gender);
    setSample_Received(brcaReport[0]?.pickup_date);
    setAge(brcaReport[0]?.customer_age)
    setName(brcaReport[0]?.customer_name);
    setDob(brcaReport[0]?.dob);
    setUuid(brcaReport[0]?.uuid);
  }, [brcaReport]);

  useEffect(() => {
    if (dob) {
      const currentDate = new Date();
      const dobDate = new Date(dob);
      const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
      const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
      setAge(ageInYears);
    }
  }, [dob]);


  // Clinical Indication
  const [brcaClinData, setBrcaClinData] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.clinical_indication &&
      reportListParameter?.clinical_indication?.length > 0
    ) {
      reportListParameter?.clinical_indication?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setBrcaClinData(brcaclincdata);
  }, [reportListParameter]);

  const updateClientIndication = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...brcaClinData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setBrcaClinData(storeData);
  }
  //varient 1
  const [varient1, setVarient1] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.variant_information &&
      reportListParameter?.variant_information?.length > 0
    ) {
      reportListParameter?.variant_information?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setVarient1(brcaclincdata);
  }, [reportListParameter]);

  const updateVarientInformation1 = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...varient1]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setVarient1(storeData);
  }

  //varient 2
  const [varient2, setVarient2] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.variant_information2 &&
      reportListParameter?.variant_information2?.length > 0
    ) {
      reportListParameter?.variant_information2?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setVarient2(brcaclincdata);
  }, [reportListParameter]);

  const updateVarientInformation2 = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...varient2]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setVarient2(storeData);
  }

  // Brca Pannel
  const [brcaPannel, setBrcaPannel] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.rcl_brca_panel &&
      reportListParameter?.rcl_brca_panel?.length > 0
    ) {
      reportListParameter?.rcl_brca_panel?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setBrcaPannel(brcaclincdata);
  }, [reportListParameter]);

  const updatePannel = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...brcaPannel]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setBrcaPannel(storeData);
  }

  const [doctorList, setDoctorList] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.doctor_list &&
      reportListParameter?.doctor_list?.length > 0
    ) {
      reportListParameter?.doctor_list?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setDoctorList(brcaclincdata);
  }, [reportListParameter]);

  const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...doctorList]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
      case "free_text":
        newItem.parameter_url = value
        break;
    }
    storeData[index] = newItem;
    setDoctorList(storeData);
  }

  // positive Negative
  const [brcaPositiveNegative, setPositiveNegative] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.brca_positive_negative &&
      reportListParameter?.brca_positive_negative?.length > 0
    ) {
      reportListParameter?.brca_positive_negative?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setPositiveNegative(brcaclincdata);
  }, [reportListParameter]);

  const updatePosiveNegative = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...brcaPositiveNegative]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setPositiveNegative(storeData);
  }

  // brca result value
  const [resultValue, setResultValue] = useState<any>([]);
  useEffect(() => {
    const brcaresultvaluedata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.brac_result_value &&
      reportListParameter?.brac_result_value?.length > 0
    ) {
      reportListParameter?.brac_result_value?.map((list: any) => {
        brcaresultvaluedata?.push({ ...list });
      });
    }
    setResultValue(brcaresultvaluedata);
  }, [reportListParameter]);

  const updateResultValue = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...resultValue]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setResultValue(storeData);
  }


  //recommendation data
  const [recommendationsData, setRecommendation] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.recommendations &&
      reportListParameter?.recommendations?.length > 0
    ) {
      reportListParameter?.recommendations?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setRecommendation(brcaclincdata);
  }, [reportListParameter]);

  const updateRecommendations = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...recommendationsData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setRecommendation(storeData);
  }

  // brca postive results
  const [brcaPostiveData, setBracPositiveData] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.result_brca &&
      reportListParameter?.result_brca?.length > 0
    ) {
      reportListParameter?.result_brca?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setBracPositiveData(brcaclincdata);
  }, [reportListParameter]);

  const updatePostiveData = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...brcaPostiveData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setBracPositiveData(storeData);
  }
  // brca Mean Data
  const [brcaMean, setBracMean] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.mean &&
      reportListParameter?.mean?.length > 0
    ) {
      reportListParameter?.mean?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setBracMean(brcaclincdata);
  }, [reportListParameter]);

  const updateMeanData = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...brcaMean]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setBracMean(storeData);
  }


  //Methodology
  const [methodology, setMethodology] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.methodology &&
      reportListParameter?.methodology?.length > 0
    ) {
      reportListParameter?.methodology?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setMethodology(brcaclincdata);
  }, [reportListParameter]);

  const updateMethodology = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...methodology]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setMethodology(storeData);
  }


  // Qc metrics 
  let metricsData = [
    {
      id: 1,
      name: "",
      val: "",
    },
    {
      id: 2,
      name: "",
      val: "",
    },
    {
      id: 3,
      name: "",
      val: "",
    },
    {
      id: 4,
      name: "",
      val: "",
    },
    {
      id: 5,
      name: "",
      val: "",
    },
    {
      id: 6,
      name: "",
      val: "",
    },
  ];

  const [qcmetricsResults, setQcMetricsResults] = useState<any>([])
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.qc_metrics &&
      reportListParameter?.qc_metrics.length > 0
    ) {
      reportListParameter?.qc_metrics?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setQcMetricsResults(data);
    // data?.length === 0 ? setQcMetrics(metricsData) : setQcMetrics(data);
  }, [reportListParameter]);

  const [tableData, setTableData] = useState<any>([])
  useEffect(() => {
    let data: any,
      parse: any,
      storeData: any = [];
    if (
      reportListParameter &&
      reportListParameter?.qc_metrics &&
      reportListParameter?.qc_metrics.length > 0
    ) {
      data = reportListParameter?.qc_metrics[0]?.parameter_value;
      if (data) {
        parse = JSON.parse(data);
      }
      if (parse?.length > 0) {
        parse?.map((list: any) => {
          storeData.push({
            ...list,
          });
        });
      } else {
        metricsData?.map((list: any) => {
          storeData.push({
            ...list,
          });
        });
      }
    }

    setTableData(storeData);

  }, [reportListParameter]);

  const updateMetricsData = (
    index: number,
    key: string,
    value: any,
    object: any
  ) => {
    let storeData = [...tableData];
    let newItem = storeData[index];
    switch (key) {
      case "name":
        newItem.name = value;
        break;
      case "val":
        newItem.val = value;
        break;
    }
    storeData[index] = newItem;
    setTableData(storeData);
  };

  //Limitations
  const [limitations, setLimitations] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.test_limitations &&
      reportListParameter?.test_limitations?.length > 0
    ) {
      reportListParameter?.test_limitations?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setLimitations(brcaclincdata);
  }, [reportListParameter]);

  const updateLimitations = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...limitations]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setLimitations(storeData);
  }

  //Gene
  const [gene, setGene] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.gene &&
      reportListParameter?.gene?.length > 0
    ) {
      reportListParameter?.gene?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setGene(brcaclincdata);
  }, [reportListParameter]);

  const updateGene = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...gene]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setGene(storeData);
  }

  //Varint
  const [varientData, setVarient] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.variant &&
      reportListParameter?.variant?.length > 0
    ) {
      reportListParameter?.variant?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setVarient(brcaclincdata);
  }, [reportListParameter]);

  const updateVarient = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...varientData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setVarient(storeData);
  }

  //zygosityDta
  const [zygosityData, setZygosity] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.zygosity &&
      reportListParameter?.zygosity?.length > 0
    ) {
      reportListParameter?.zygosity?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setZygosity(brcaclincdata);
  }, [reportListParameter]);

  const updateZygosity = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...zygosityData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setZygosity(storeData);
  }

  //location
  const [locataionData, setLocationData] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.location &&
      reportListParameter?.location?.length > 0
    ) {
      reportListParameter?.location?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setLocationData(brcaclincdata);
  }, [reportListParameter]);

  const updateLocation = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...locataionData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setLocationData(storeData);
  }
  //disoreder
  const [disorderData, setDisorder] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.disorder &&
      reportListParameter?.disorder?.length > 0
    ) {
      reportListParameter?.disorder?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setDisorder(brcaclincdata);
  }, [reportListParameter]);

  const updateDisorder = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...disorderData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setDisorder(storeData);
  }
  //Inheritance
  const [inheritanceData, setInheritance] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.inheritance &&
      reportListParameter?.inheritance?.length > 0
    ) {
      reportListParameter?.inheritance?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setInheritance(brcaclincdata);
  }, [reportListParameter]);

  const updateInheritance = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...inheritanceData]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setInheritance(storeData);
  }

  //Sample Type
  const [sampletype, setsampletype] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.sample_type &&
      reportListParameter?.sample_type.length > 0
    ) {
      reportListParameter?.sample_type?.map((list: any) => {
        data?.push({ ...list });
      });
    }
    setsampletype(data);
  }, [reportListParameter]);

  const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...sampletype]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setsampletype(storeData);
  }

  // Hospital Id

  const [HospitalId, setHospitalId] = useState<any>([]);
  useEffect(() => {
    const data: any = [];
    if (
      reportListParameter &&
      reportListParameter?.Hospital_Id
      &&
      reportListParameter?.Hospital_Id

        .length > 0
    ) {
      reportListParameter?.Hospital_Id

        ?.map((list: any) => {
          data?.push({ ...list });
        });
    }
    setHospitalId(data);
  }, [reportListParameter]);

  const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...HospitalId]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value;
        break;
    }
    storeData[index] = newItem;
    setHospitalId(storeData);
  }
  //ACMG
  const [acmg, setAcmg] = useState<any>([]);
  useEffect(() => {
    const brcaclincdata: any = [];
    if (
      reportListParameter &&
      reportListParameter?.ACMG_Classification &&
      reportListParameter?.ACMG_Classification?.length > 0
    ) {
      reportListParameter?.ACMG_Classification?.map((list: any) => {
        brcaclincdata?.push({ ...list });
      });
    }
    setAcmg(brcaclincdata);
  }, [reportListParameter]);

  const updateAcmg = (id: number, value: any, index: number, key: string, object: any) => {
    let storeData = [...acmg]
    let newItem = object;
    switch (key) {
      case "free_text":
        newItem.parameter_value = value
        break;
    }
    storeData[index] = newItem;
    setAcmg(storeData);
  }

  useEffect(() => {
    if (thirdP !== "add") {
      getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
    } else {
      getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
    }
  }, [])

  const submitData = async (e: any) => {
    e.preventDefault();

    let storeData: any = [];

    if (brcaReport.length > 0) {
      brcaReport?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (brcaClinData.length > 0) {
      brcaClinData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (brcaPannel.length > 0) {
      brcaPannel?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (brcaPositiveNegative.length > 0) {
      brcaPositiveNegative?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (recommendationsData.length > 0) {
      recommendationsData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (brcaPostiveData.length > 0) {
      brcaPostiveData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (brcaMean.length > 0) {
      brcaMean?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (methodology.length > 0) {
      methodology?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (limitations.length > 0) {
      limitations?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (varient1.length > 0) {
      varient1?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (varient2.length > 0) {
      varient2?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (gene.length > 0) {
      gene?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (varientData.length > 0) {
      varientData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (zygosityData.length > 0) {
      zygosityData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (locataionData.length > 0) {
      locataionData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (disorderData.length > 0) {
      disorderData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (inheritanceData.length > 0) {
      inheritanceData?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (HospitalId.length > 0) {
      HospitalId?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (acmg.length > 0) {
      acmg?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (doctorList.length > 0) {
      doctorList?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (resultValue.length > 0) {
      resultValue?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    if (sampletype.length > 0) {
      sampletype?.map((list: any) => {
        storeData.push({
          ...list,
        });
      });
    }
    const stringify = JSON.stringify(tableData);
    if (qcmetricsResults.length > 0) {
      qcmetricsResults?.map((list: any) => {
        storeData.push({
          ...list,
          parameter_value: stringify,
        });
      });
    }

    // const reportData = {
    //   template_id: secondP,
    //   booking_id: firstP,
    //   case_id: firstP,
    //   status: status,
    //   template_parameter: storeData,
    // };
    // const reportEditData = {
    //   template_id: secondP,
    //   booking_id: firstP,
    //   case_id: firstP,
    //   status: status,
    //   template_parameter: storeData,
    // };
    // if (thirdP === "add") {
    //   await createNewReport(reportData);
    //   navigate('/dashboard/la');
    // } else if (thirdP === "edit") {
    //   await updateReport(reportListParameter?.id, reportEditData);
    // }
    const reportData = {
      template_id: secondP,
      booking_id: firstP,
      case_id: firstP,
      template_parameter: storeData,
      dob: dob,
      customer_age: age,
      status: status,
      collection_date: Sample_Collected,
      pickup_date: Sample_Received,
      pickup_time: Sample_Receivedtime,
      customer_gender: Gender,
      customer_name: Name,
      designation: designation,
    };
    const reportEditData = {
      template_id: secondP,
      booking_id: firstP,
      case_id: firstP,
      status: status,
      template_parameter: storeData,
      dob: dob,
      customer_age: age,
      collection_date: Sample_Collected,
      pickup_date: Sample_Received,
      pickup_time: Sample_Receivedtime,
      customer_gender: Gender,
      customer_name: Name,
      designation: designation,
    };

    if (thirdP === "add") {
      await createNewReport(reportData);
      navigate('/dashboard/la');
    } else if (thirdP === "edit") {
      await updateReport(reportListParameter?.id, reportEditData);
      if (thirdP === "edit") {
        if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
          await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
        } else {
          console.error("Missing dob value for updateNiptDob");
        }
      } else {
        await createNiptDob(reportListParameter?.id, {
          dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
        });
      }
    }
  };

  const [barcodeValue, setBarcodeValue] = React.useState(
    JSON.stringify({
      date_time: moment().format(),
    })
  );

  const handleClick = (event: any) => {
    setBarcodeValue(
      JSON.stringify({
        date_time: moment().format(),
      })
    );
    setAnchorEl(event.currentTarget);
  };

  function autoSetTextAreaHeight(textarea: HTMLTextAreaElement) {
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  }

  useEffect(() => {
    resetBookingData();
  }, [])

  const [uhid, setuhid] = useState<any>([]);
  const [tempCode, setTempCode] = useState<any>([]);
  useEffect(() => {
    setuhid(reportListParameter?.uhid)
    setTempCode(reportListParameter?.template_code)
  }, [reportListParameter])
  const documentTitle = `${brcaReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;

  return (
    <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
      <div style={{ margin: "55px auto" }}>
        <div>
          <div style={{ height: "20px" }}>
            <div>
              {thirdP !== "add" && (
                <ReactToPrint
                  content={reactToPrintContent}
                  trigger={reactToPrintTrigger}
                  documentTitle={documentTitle}
                />
              )}
            </div>
          </div>
          <div style={{ width: "200px", marginLeft: "780px" }}>
            <TextField
              id="outlined-select-currency"
              select
              variant="outlined"
              fullWidth
              className={classes.input}
              label="Select Report Type"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              style={{ height: "30px" }}
            >
              <MenuItem value={"Draft"}>Draft</MenuItem>
              <MenuItem value={"Editable"}>Editable</MenuItem>
              <MenuItem value={"Approved"}>Approved</MenuItem>
              <MenuItem value={"Hold"}>Hold</MenuItem>
              <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
            </TextField>
          </div>
          <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
            <div>
              <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
            </div>
          </div>
        </div>
        {loading ? (
          <Loader />
        ) : (
          <div
            id="PAGE"
            ref={componentRef}
            style={{
              width: 1122,
              background: "#fff",
            }}
          >
            {/* header section */}
            <div className="page-header">
              <div style={{ padding: "20px" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    background: "#fff",
                  }}
                >
                  <div style={{ width: "80%", padding: 15 }}>
                    <div
                      style={{
                        color: "#1A5276",
                        fontWeight: "bold",
                        fontSize: "30px",
                        textAlign: "left",
                      }}
                    >
                      LABORATORY REPORT
                    </div>
                  </div>
                  <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                    <h3>
                      <img src={logo} alt="logo" style={{ width: "200px" }} />
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            {/* header section closed */}

            {/* patient section details */}

            <div style={{ padding: 15, width: "100%" }} className="bodyPage">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  background: "#fff",
                }}
              >
                <img
                  src={designLogo}
                  alt="logo"
                  style={{ height: "150px", width: "50%" }}
                />
                <div style={{ width: "90%", textAlign: "center" }}>
                  <div
                    style={{
                      color: "#b52155",
                      fontWeight: "bold",
                      fontSize: "30px",
                      marginRight: "310px",
                    }}
                  >
                    <img
                      src={headerLogo}
                      alt="logo"
                      style={{ height: "50px", width: "50%", marginTop: "40px", marginLeft: "-110px" }}
                    />
                  </div>
                </div>
              </div>
              {/* 1 */}
              <Paper style={{ backgroundColor: "#F8F8F8" }}>
                <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="marginLeft-a">
                  <Grid item xs={6.5}>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                        <Grid item xs={4}>
                          Patient Name
                        </Grid>
                        <Grid item xs={8}>
                          :  <input
                            className="input"
                            style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                            type="text"
                            value={designation}
                            onChange={(e) => setdesignation(e.target.value)}
                          />
                          <input
                            className="input"
                            style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                            type="text"
                            value={Name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                        <Grid item xs={4}>
                          Age:
                        </Grid>

                        <Grid item xs={8}>
                          :  <input
                            className="input"
                            style={{ border: "none", width: "8%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                            type="text"
                            value={age}
                            onChange={(e) => setAge(e.target.value)} />Y
                        </Grid>
                        {/* <Grid item xs={8}>
                          : {brcaReport[0]?.customer_age}Y
                        </Grid> */}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                        <Grid item xs={4}>
                          Gender
                        </Grid>
                        <Grid item xs={8}>
                          :  <input
                            className="input"
                            style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                            type="text"
                            value={Gender}
                            onChange={(e) => setGender(e.target.value)}
                          />
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                        <Grid item xs={4}>
                          Referring Clinician
                        </Grid>
                        <Grid item xs={8}>
                          : {brcaReport[0]?.doctor_name
                            ? brcaReport[0]?.doctor_name
                            : "NA"}
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                        <Grid item xs={4}>
                          Barcode No:
                        </Grid>
                        <Grid item xs={8}>
                          : {brcaReport[0]?.barcode
                            ? brcaReport[0]?.barcode
                            : "NA"}
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      {brcaReport[0]?.center?.name && brcaReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                          <Grid item xs={4.2}>
                            Hospital ID
                          </Grid>
                          <Grid item xs={8.5}>
                            : {HospitalId?.map((list: any, index: number) => {
                              return (
                                <input
                                  key={list?.id}
                                  style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                  value={list?.parameter_value}
                                  onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                />
                              );
                            })}
                          </Grid>
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                  {/* rest half page---------------------------> */}
                  <Grid item xs={5.5}>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <Grid item xs={5}>
                        </Grid>
                        <Grid item xs={7}>
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <Grid item xs={5}>
                          Booking ID:
                        </Grid>
                        <Grid item xs={7}>
                          :{brcaReport[0]?.pk
                            ? brcaReport[0]?.pk
                            : "NA"}
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <Grid item xs={5}>
                          Sample Type:
                        </Grid>
                        <Grid item xs={7}>
                          : {sampletype?.map((list: any, index: number) => {
                            return (
                              <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                <option value="normal">NA</option>
                                <option value="EDAT">Amniotic Fluid </option>
                                <option value="Venous">Chorionic Villi </option>
                                <option value="Arterial">Fetal Cord Blood</option>
                                <option value="Abortus">Product of Conception</option>
                                <option value="Placenta">Placenta</option>
                                <option value="Fetal">Fetal Cord (PUBS)</option>
                                <option value="Peripheral">Peripheral Blood</option>
                                <option value="Peripheral1">Pre Natal Cord </option>
                                <option value="dna">DNA</option>
                                <option value="blood">Blood</option>
                                <option value="whole blood edta"> Whole Blood EDTA </option>
                                <option value="ffpe tissue block"> FFPE TISSUE BLOCK </option>
                                <option value="Bone Marrow">Bone Marrow</option>
                              </select>
                            )
                          })
                          }
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <Grid item xs={5}>
                          Sample Collection Date:
                        </Grid>
                        <Grid item xs={7}>
                          :  <input
                            className="input"
                            style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                            type="text"
                            placeholder="yyyy-mm-dd"
                            pattern="\d{4}-\d{2}-\d{2}"
                            value={Sample_Collected}
                            onChange={(e) => setSample_Collected(e.target.value)}
                          />
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <Grid item xs={5}>
                          Sample Collection Time:
                        </Grid>
                        <Grid item xs={7}>
                          :<input
                            className="input"
                            style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                            type="text"
                            placeholder="HH:MM:SS"
                            value={Sample_Receivedtime?.split('.')[0]}
                            onChange={(e) => setSample_Receivedtime(e.target.value)}
                          />
                        </Grid>
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                        <Grid item xs={5}>
                          Reporting Date:
                        </Grid>
                        <Grid item xs={7}>
                          : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>

              {/* 2 */}
              <div style={{ width: "90%", marginLeft: "50px" }}>
                <h6 style={{ backgroundColor: "#035880", color: "white", textAlign: "center", borderRadius: "8px", height: "35px", marginTop: "1px", padding: "6px" }}><p style={{ fontWeight: "bold", textAlign: "center" }}>Test Performed:-{brcaReport[0]?.packages[0]?.name}</p></h6>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",
                }}
              >
                <div style={{ width: "100%", marginLeft: 6, marginTop: "-3px" }}>
                  <h6>Clinical Indication:</h6>
                  {brcaClinData?.map((list: any, index: number) => {
                    return (
                      <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                        <GrammarlyEditorPlugin>
                          <textarea
                            style={{ border: "none", resize: "none" }}
                            rows={2}
                            cols={138}
                            value={list?.parameter_value}
                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                          />
                        </GrammarlyEditorPlugin>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div style={{
                border: "2px solid",
                borderRadius: "6px",
                borderStyle: "dashed",
                marginTop: "-18px"
              }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    color: "#1A5276",
                    // padding: "5px",
                    marginTop: "-1px"

                  }}
                >
                  <div style={{ fontWeight: "bold", fontSize: "25px", color: "white", height: "45px", width: "100%" }} className="box">
                    <img
                      src={testLogo}
                      alt="logo"
                      style={{ margin: "2px", height: "30px" }}
                    />
                    &nbsp;&nbsp;TEST RESULTS
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    background: "#fff",
                    padding: "6px",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      textAlign: "center",
                      marginBottom: "10px",
                    }}
                  >
                    {resultValue?.map((list: any, index: number) => {
                      return (
                        <div
                          style={{
                            color: "#ff0000",
                            fontWeight: "bold",
                            fontSize: "25px",
                            marginTop: "5px",
                          }}>
                          <Select style={{ border: "none", outline: "none", appearance: "none", textDecoration: "none" }} value={list?.parameter_value} onChange={(e) => updateResultValue(list?.id, e.target.value, index, "free_text", list)}>
                            <MenuItem value="Negative"><span style={{ fontSize: "30px", color: "green", fontWeight: "bold" }}>Negative</span></MenuItem>
                            <MenuItem value="Positive"><span style={{ fontSize: "30px", color: "red", fontWeight: "bold" }}>Positive</span></MenuItem>
                            <MenuItem value="VUS"><span style={{ fontSize: "30px", fontWeight: "bold", color: "rgb(22 55 88)" }}>VUS</span></MenuItem>
                          </Select>
                        </div>
                      )
                    })}
                    {brcaPositiveNegative?.map((list: any, index: number) => {
                      return (
                        <div style={{ width: "45%", padding: 15, textAlign: "center", marginTop: "-15px", fontSize: "16px" }}>
                          <GrammarlyEditorPlugin>
                            <textarea
                              style={{ border: "none", resize: "none", textAlign: "center", fontWeight: "bold" }}
                              rows={2}
                              cols={112}
                              value={list?.parameter_value}
                              onChange={(e) => updatePosiveNegative(list?.id, e.target.value, index, "free_text", list)}
                            />
                          </GrammarlyEditorPlugin>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
              {/* 5.1 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  borderLeft: "2px solid red",
                  marginTop: "20px",
                }}
              >
                <h5 style={{ fontWeight: "bold", marginLeft: "10px" }}>Key Finding</h5>
              </div>
              <div className="grid-table" >
                <div className="table-header-a">Gene & Transcript</div>
                <div className="table-header-a">Exon</div>
                <div className="table-header-a">Variant</div>
                <div className="table-header-a">Zygosity</div>
                <div className="table-header-a">Inheritance</div>
                <div className="table-header-a">ACMG Classification</div>
                {gene?.map((list: any, index: number) => {
                  return (
                    <textarea
                      className="table-row-a"
                      defaultValue={list?.parameter_value}
                      onChange={(e: any) => {
                        updateGene(list?.id, e.currentTarget.value, index, "free_text", list);
                      }}
                      rows={3}
                      style={{
                        // unicodeBidi: 'plaintext',
                        textAlign: 'center',
                        resize: "none",
                        borderColor: "black",
                        height: "85px",
                      }}
                    />
                  )
                })
                }
                {disorderData?.map((list: any, index: number) => {
                  return (
                    <textarea
                      className="table-row-a"
                      defaultValue={list?.parameter_value}
                      onChange={(e: any) => {
                        updateDisorder(list?.id, e.currentTarget.value, index, "free_text", list);
                      }}
                      rows={3}
                      style={{ textAlign: 'center', resize: "none", borderColor: "black" }}
                    />
                  )
                })
                } {varientData?.map((list: any, index: number) => {
                  return (
                    <textarea
                      className="table-row-a"
                      defaultValue={list?.parameter_value}
                      onChange={(e: any) => {
                        updateVarient(list?.id, e.currentTarget.value, index, "free_text", list);
                      }}
                      rows={3}
                      style={{ textAlign: 'center', resize: "none", borderColor: "black" }}
                    />
                  )
                })
                } {zygosityData?.map((list: any, index: number) => {
                  return (
                    <textarea
                      className="table-row-a"
                      defaultValue={list?.parameter_value}
                      onChange={(e: any) => {
                        updateZygosity(list?.id, e.currentTarget.value, index, "free_text", list);
                      }}
                      rows={3}
                      style={{ textAlign: 'center', resize: "none", borderColor: "black" }}
                    />
                  )
                })
                }
                {inheritanceData?.map((list: any, index: number) => {
                  return (
                    <textarea
                      className="table-row-a"
                      defaultValue={list?.parameter_value}
                      onChange={(e: any) => {
                        updateInheritance(list?.id, e.currentTarget.value, index, "free_text", list);
                      }}
                      rows={3}
                      style={{ textAlign: 'center', resize: "none", borderColor: "black" }}
                    />
                  )
                })
                }
                {acmg?.map((list: any, index: number) => {
                  return (
                    <textarea
                      className="table-row-a"
                      defaultValue={list?.parameter_value}
                      onChange={(e: any) => {
                        updateAcmg(list?.id, e.currentTarget.value, index, "free_text", list);
                      }}
                      rows={3}
                      style={{ unicodeBidi: 'plaintext', textAlign: 'center', resize: "none", borderColor: "black" }}
                    />
                  )
                })
                }
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",
                  marginTop: "30px",
                  borderLeft: "2px solid red",
                }}
              >
                <div style={{ width: "100%", marginLeft: 12, fontWeight: "bold" }}>
                  <h5>
                    Detailed Variant Information (Variants Relevant To Indication For Testing)
                  </h5>
                </div>
              </div>
              {/* 7 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  marginTop: "-19px",
                  padding: "5px",
                }}
              >

                <div style={{ width: "50%", marginLeft: 10 }}
                >
                  {varient1?.map((list: any, index: number) => {
                    return (
                      <div style={{ width: "45%", padding: 15, textAlign: "left", fontSize: "15px" }}>
                        <GrammarlyEditorPlugin>
                          <textarea
                            style={{ border: "none", resize: "none" }}
                            rows={6}
                            cols={137}
                            value={list?.parameter_value}
                            onChange={(e) => updateVarientInformation1(list?.id, e.target.value, index, "free_text", list)}
                          />
                        </GrammarlyEditorPlugin>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="bodyMargin2">
                <p>.</p>
              </div>
              {(navigator.userAgent.includes("Chrome")) ? "" :
                <div className="bodyMargin2">
                  <p>.</p>
                </div>}
              <div style={{ marginTop: "17px", marginLeft: "8px", padding: "3px", background: "#EEEEEE", borderRadius: "0px 10px", width: "730px", height: "30px" }}>
                <h6> Patient Name: &nbsp;
                  {brcaReport[0]?.designation}&nbsp;
                  {brcaReport[0]?.customer_name} &nbsp;&nbsp;&nbsp;Booking Id:&nbsp;{brcaReport[0]?.pk} </h6>
              </div>

              {/* Qc Metrics */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  marginTop: "9px",
                  borderLeft: "2px solid red",
                }}
              >
                <div style={{ width: "100%", marginLeft: 12 }}>
                  <h5><b>QC Metrics</b></h5>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  border: "1px solid",
                  color: "#1A5276",
                  borderRadius: "5px",
                  borderStyle: "solid",
                }}
              >
                <div style={{ width: "100%", marginLeft: 12, }}>
                  <Table>
                    <colgroup>
                      <col style={{ width: '60%' }} />
                      <col style={{ width: '40%' }} />
                    </colgroup>
                    <TableHead>
                    </TableHead>
                    {tableData?.length > 0 &&
                      tableData?.map((list: any, index: number) => {
                        return (
                          <>
                            <TableBody key={index}
                              className={index % 2 === 0 ? 'even-row' : 'odd-row'}>
                              <TableCell className={classes.tableCell} align="left">
                                <GrammarlyEditorPlugin>
                                  <input
                                    style={{ border: "none", textAlign: "left", width: "100%", background: "none" }}
                                    value={list?.name}
                                    onChange={(e: any) =>
                                      updateMetricsData(
                                        index,
                                        "name",
                                        e.target.value,
                                        list
                                      )
                                    }
                                  />
                                </GrammarlyEditorPlugin>
                              </TableCell>
                              <TableCell
                                className={classes.tableCell}
                                align="center"
                              >
                                <GrammarlyEditorPlugin>
                                  <input
                                    style={{ border: "none", textAlign: "left", width: "100%", background: "none" }}
                                    value={list?.val}
                                    onChange={(e: any) =>
                                      updateMetricsData(
                                        index,
                                        "val",
                                        e.target.value,
                                        list
                                      )
                                    }
                                  />
                                </GrammarlyEditorPlugin>
                              </TableCell>
                            </TableBody>
                          </>
                        );
                      })}
                  </Table>
                </div>
              </div >

              {/* recomendations */}
              < div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  marginTop: "9px",
                  borderLeft: "2px solid red",
                }}
              >
                <div style={{ width: "100%", marginLeft: 12 }}>
                  <h5> <b>Recommendations:</b></h5>
                </div>
              </div >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",
                }}
              >
                <div style={{ width: "100%", marginLeft: 12, marginTop: "-10px" }}>
                  <h6>
                    Based on the clinical features and the observed genetic findings
                    the following have been recommended:
                  </h6>
                  {recommendationsData?.map((list: any, index: number) => {
                    return (
                      <div style={{ width: "45%", padding: 15, textAlign: "left" }}>
                        <GrammarlyEditorPlugin>
                          <textarea
                            style={{ border: "none", resize: "none", fontSize: "15px" }}
                            rows={5}
                            cols={139}
                            value={list?.parameter_value}
                            onChange={(e) => updateRecommendations(list?.id, e.target.value, index, "free_text", list)}
                          />
                        </GrammarlyEditorPlugin>
                      </div>
                    )
                  })}

                </div>
              </div>
              {/* recomendations  closed */}
              {/* Test Description*/}
              < div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  marginTop: "-9px",
                  borderLeft: "2px solid red",
                }}
              >
                <div style={{ width: "100%", marginLeft: 12 }}>
                  <h5> <b>Test Description:</b></h5>
                </div>
              </div >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",
                }}
              >
                <div style={{ width: "100%", marginLeft: 12 }}>
                  <p>
                    BRCA1 (BReast CAncer gene 1) and BRCA2 (BReast CAncer gene 2) are genes that produce proteins that help repair
                    damaged DNA. Everyone has two copies of each of these genes--one copy inherited from each parent. BRCA1 and
                    BRCA2are tumor suppressor genes. When they have certain changes, called pathogenic variants (or mutations), cancer
                    can develop..</p>
                  <p>People who inherit pathogenic variants in one of these genes have increased risks of several cancers-most notably breast
                    and ovarian cancer, but also several additional types of cancer. People who have inherited a pathogenic variant in BRCA1
                    and BRCA2 also tend to develop cancer at younger ages than people who do not have such a variant.</p>
                  <p>This test uses Next Generation Sequencing, targeted sequencing approach that is restricted to the protein-coding regions
                    of selected genes under investigation. BRCA1 and BRCA2 Panel contains primer pairs that target the coding regions of the
                    tumor suppressor genes BRCA1 and BRCA2, which have been implicated in hereditary breast and ovarian cancers.
                  </p>

                </div>
              </div>
              {/*Test Description closed */}

              {/* brcapostive results   */}
              {/* 9 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  marginTop: "25px",
                  borderLeft: "2px solid red",
                }}
              >
                <div style={{ width: "100%", marginLeft: 12 }}>
                  <h5>
                    <b>What is a positive BRCA result?</b>
                  </h5>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",

                }}
              >
                <div
                  style={{
                    width: "8%",
                    height: "84px",
                    padding: "5px",
                    border: "2px solid",
                    color: "#1A5276",
                    borderRadius: "50%",
                  }}
                >
                  <img src={brcaresult} alt="brcaresult" />
                </div>
                {brcaPostiveData?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "45%", padding: 15, textAlign: "left" }}>
                      <GrammarlyEditorPlugin>
                        <textarea
                          style={{ border: "none", resize: "none" }}
                          rows={4}
                          cols={130}
                          value={list?.parameter_value}
                          onChange={(e) => updatePostiveData(list?.id, e.target.value, index, "free_text", list)}
                        />
                      </GrammarlyEditorPlugin>
                    </div>
                  )
                })}
              </div>
              <div className="bodyMargin2">
                .
              </div>
              {(navigator.userAgent.includes("Chrome")) ? "" :
                <div className="bodyMargin2">
                  <p>.</p>
                </div>}
              <div style={{ marginTop: "17px", marginLeft: "8px", padding: "3px", background: "#EEEEEE", borderRadius: "0px 10px", width: "730px", height: "30px" }}>
                <h6> Patient Name: &nbsp;
                  {brcaReport[0]?.designation}&nbsp;
                  {brcaReport[0]?.customer_name} &nbsp;&nbsp;&nbsp;Booking Id:&nbsp;{brcaReport[0]?.pk} </h6>
              </div>
              {/* 10 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  borderLeft: "2px solid red",
                }}
              >
                <div
                  style={{ width: "100%", marginLeft: 12 }}
                  className="marginBody"
                >
                  <h5>
                    <b>What does this mean?</b>
                  </h5>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",
                  marginTop: "-19px",
                }}
              >
                {brcaMean?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "45%", padding: 15, textAlign: "left" }}>
                      <GrammarlyEditorPlugin>
                        <textarea
                          style={{ border: "none", resize: "none" }}
                          rows={5}
                          cols={147}
                          value={list?.parameter_value}
                          onChange={(e) => updateMeanData(list?.id, e.target.value, index, "free_text", list)}
                        />
                      </GrammarlyEditorPlugin>
                    </div>
                  )
                })}
              </div>

              {/* 11 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  borderLeft: "2px solid red",
                  marginTop: "-15px"
                }}
              >
                <div
                  style={{ width: "100%", marginLeft: 12 }}
                  className="marginBody"
                >
                  <h5>
                    <b>What does this mean for family members?</b>
                  </h5>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",
                }}
              >
                <div
                  style={{
                    width: "6%",
                    marginLeft: 12,
                    padding: "5px",
                    border: "2px solid",
                    color: "#1A5276",
                    borderRadius: "50%",
                  }}
                >
                  <img src={family} alt="brcaresult" />
                </div>
                <>
                  <div style={{ width: "65%", marginLeft: 12, marginTop: "15px" }}>
                    <p>The image on the right demonstrates how variants in BRCA can be passed on from generation to generation.</p>
                  </div>
                </>
              </div>
              {/* 12 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  padding: "5px",
                  marginTop: "30px",
                }}
              >
                <div style={{ width: "67%", marginLeft: 12 }}>
                  <h5>
                    <b>Who should be tested next?</b>
                  </h5>
                  <p>Parents, siblings, children, and other relatives may also have this BRCA variant. Both men and women can inherit and pass on a BRCA variant. People may have different conditions or symptoms depending on whether they inherit one or two variants in BRCA. For individuals who are planning a family, reproductive options may be available to help lower the chance of passing on the variant to a child.</p>
                  A BRCA variant affects everyone differently. Family members with the variant may develop cancer at different ages, or they may never develop cancer.
                </div>
                <div style={{ width: "35%", marginLeft: 12, marginTop: "15px" }}>
                  <img src="https://static-redcliffelabs.s3.amazonaws.com/media/gallary-file/None/957f433c-ffdb-4230-aafa-0c664708fccb.jpg" style={{ width: "240px" }} />
                </div>
              </div>
              {/* 13 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  marginTop: "-15px",
                  borderLeft: "2px solid red",
                }}
              >
                <div
                  style={{ width: "100%", marginLeft: 12 }}>
                  <h5>
                    <b>Methodology</b>
                  </h5>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",
                  marginTop: "-19px"
                }}
              >
                {methodology?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "45%", padding: 15, textAlign: "left" }}>
                      <GrammarlyEditorPlugin>
                        <textarea
                          style={{ border: "none", resize: "none" }}
                          rows={12}
                          cols={147}
                          value={list?.parameter_value}
                          onChange={(e) => updateMethodology(list?.id, e.target.value, index, "free_text", list)}
                        />
                      </GrammarlyEditorPlugin>
                    </div>
                  )
                })}
              </div>
              {/* 15 */}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  color: "#1A5276",
                  padding: "5px",
                  borderLeft: "2px solid red",
                }}
              >
                <div
                  style={{ width: "100%", marginLeft: 12 }}
                  className="marginBody"
                >
                  <h5>
                    <b>Test Limitations</b>
                  </h5>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  margin: "10px 0px",
                  textAlign: "start",
                  padding: "5px",
                  marginTop: "-19px"
                }}
              >
                {limitations?.map((list: any, index: number) => {
                  return (
                    <div style={{ width: "45%", padding: 15, textAlign: "left" }}>
                      <GrammarlyEditorPlugin>
                        <textarea
                          style={{ border: "none", resize: "none" }}
                          rows={7}
                          cols={147}
                          value={list?.parameter_value}
                          onChange={(e) => updateLimitations(list?.id, e.target.value, index, "free_text", list)}
                        />
                      </GrammarlyEditorPlugin>
                    </div>
                  )
                })}
              </div>

            </div >
            {resultValue[0]?.parameter_value === "Positive" ?
              <>
                <div className="bodyMargin6">.</div>
                {/* patient details section closed */}
                <div style={{ marginTop: "17px", marginLeft: "17px", padding: "3px", background: "#EEEEEE", borderRadius: "0px 10px", width: "730px", height: "30px" }}>
                  <h6> Patient Name: &nbsp;
                    {brcaReport[0]?.designation}&nbsp;
                    {brcaReport[0]?.customer_name} &nbsp;&nbsp;&nbsp;Booking Id:&nbsp;{brcaReport[0]?.pk} </h6>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    color: "#1A5276",
                    padding: "5px",
                    borderLeft: "2px solid red",
                    marginLeft: 12,
                  }}
                  className="merginLeft"
                >
                  <div
                    style={{ width: "100%", marginLeft: 12 }}>
                    <h5>
                      <b>FDA approved drugs with BRCA1 and BRCA2 mutations</b>
                    </h5>
                  </div>

                </div>
                <div style={{ width: "100%" }}
                  className="merginLeft"
                >
                  <div
                    style={{
                      color: "#fff",
                      marginTop: "10px",
                      fontWeight: "bold",
                      fontSize: "20px",
                      borderRadius: "14px 14px",
                      backgroundColor: "#1A5276",
                      width: "60%",
                      textAlign: "center",
                      marginLeft: "33px",
                    }}
                  >
                    Gene - BRCA1 &nbsp;&nbsp;&nbsp;&nbsp; Mutation - Oncogenic
                    Mutations
                  </div>
                </div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    textAlign: "start",
                    padding: "5px",
                    marginTop: "10px",
                  }}
                >
                  <div style={{ width: "50%", marginLeft: 12, color: "#1A5276" }}>
                    <h5>
                      <b>Disease</b>
                    </h5>
                  </div>
                  <div style={{ width: "50%", marginLeft: "430px", color: "red" }}>
                    <h5>
                      <b>Drug</b>
                    </h5>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Ovary/Fallopian Tube, Ovarian Cancer, Peritoneal Serous
                    Carcinoma
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>Niraparib</div>
                </div>

                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Ovary/Fallopian Tube, Ovarian Cancer, Peritoneal Serous
                    Carcinoma
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>
                    Olaparib, Olaparib + Bevacizumab
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Ovary/Fallopian Tube, Ovarian Cancer, Peritoneal Serous
                    Carcinoma
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>Rucaparib</div>
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Prostate Cancer, NOS, Prostate Cancer
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>Olaparib</div>
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Prostate Cancer, NOS, Prostate Cancer
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>Rucaparib</div>
                </div>
                <div style={{ width: "100%" }}>
                  <div
                    style={{
                      color: "#fff",
                      marginTop: "10px",
                      fontWeight: "bold",
                      fontSize: "20px",
                      borderRadius: "14px 14px",
                      backgroundColor: "#1A5276",
                      width: "60%",
                      textAlign: "center",
                      marginLeft: "33px",
                    }}
                  >
                    Gene - BRCA2 &nbsp;&nbsp;&nbsp;&nbsp; Mutation - Oncogenic
                    Mutations
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    margin: "10px 0px",
                    textAlign: "start",
                    padding: "5px",
                    marginTop: "10px",
                  }}
                >
                  <div style={{ width: "50%", marginLeft: 12, color: "#1A5276" }}>
                    <h5>
                      <b>Disease</b>
                    </h5>
                  </div>
                  <div style={{ width: "50%", marginLeft: "430px", color: "red" }}>
                    <h5>
                      <b>Drug</b>
                    </h5>
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Ovary/Fallopian Tube, Ovarian Cancer, Peritoneal Serous
                    Carcinoma
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>Niraparib</div>
                </div>

                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    // justifyContent: "space-between",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Ovary/Fallopian Tube, Ovarian Cancer, Peritoneal Serous
                    Carcinoma
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>
                    Olaparib, Olaparib + Bevacizumab
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Ovary/Fallopian Tube, Ovarian Cancer, Peritoneal Serous
                    Carcinoma
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>Rucaparib</div>
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Prostate Cancer, NOS, Prostate Cancer
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>Olaparib</div>
                </div>
                <div
                  style={{
                    width: "100%",
                    padding: "9px",
                    display: "flex",
                    textAlign: "start",
                  }}
                >
                  <div style={{ width: "70%", marginLeft: 8 }}>
                    Prostate Cancer, NOS, Prostate Cancer
                  </div>
                  <div style={{ width: "30%", marginLeft: 8 }}>Rucaparib</div>
                </div>

                <div className="bodyMargin7">.</div>
              </>
              : ""}
            <div className="bodyMargin6">.</div>
            {resultValue[0]?.parameter_value === "Positive" ?
              <div className="bodyMargin6">.</div> : ""}
            {/* patient details section closed */}
            <div style={{ marginTop: "17px", marginLeft: "17px", padding: "3px", background: "#EEEEEE", borderRadius: "0px 10px", width: "730px", height: "30px" }}>
              <h6> Patient Name: &nbsp;
                {brcaReport[0]?.designation}&nbsp;
                {brcaReport[0]?.customer_name} &nbsp;&nbsp;&nbsp;Booking Id:&nbsp;{brcaReport[0]?.pk} </h6>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                margin: "10px 0px",
                color: "#1A5276",
                padding: "5px",
                borderLeft: "2px solid red",
                marginLeft: "14px"
              }}
              className="marginBody"
            >
              <div className="marginBody"
                style={{ width: "100%", marginLeft: 12 }}>
                <h5>
                  <b>Variant Classification Based On Acmg Recommendations</b>
                </h5>
              </div>
            </div>

            {/* 17 */}
            <div
              style={{
                width: "100%",
                display: "flex",
                margin: "10px 0px",
                textAlign: "start",
                padding: "5px",
              }}
              className="marginBody"
            >
              <div style={{ width: "100%", marginLeft: 12 }}>
                {" "}
                <p>
                  <h6>
                    Genetic test results are reported based on the recommendations
                    of American College of Medical Genetics (ACMG) as described
                    below [1].
                  </h6>
                </p>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                padding: "9px",
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
              className="marginBody"
            >
              <div style={{ width: "30%", marginLeft: 8, color: "#1A5276" }}>
                <b>Variant</b>
              </div>
              <div style={{ width: "70%", marginLeft: 8 }}>
                A change in a gene. This could be disease causing (pathogenic)
                or not disease causing (benign).
              </div>
            </div>
            <div
              style={{
                width: "100%",
                padding: "9px",
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
              className="marginBody"
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  textAlign: "start",
                  borderRadius: "1px 1px",
                  backgroundColor: "#dbd7d7",
                  paddingBlock: "5px",
                }}
              >
                <div style={{ width: "30%", marginLeft: 8, color: "#1A5276" }}>
                  <b>Pathogenic</b>
                </div>
                <div style={{ width: "70%", marginLeft: 24 }}>
                  A disease-causing variation in a gene which can explain the
                  patients’ symptoms.
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                padding: "9px",
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
              className="marginBody"
            >
              <div style={{ width: "30%", marginLeft: 8, color: "#1A5276" }}>
                <b>Likely pathogenic</b>
              </div>
              <div style={{ width: "70%", marginLeft: 8 }}>
                A variant which is very likely to contribute to the development
                of disease. However, the scientific evidence is currently
                insufficient to prove this conclusively. Additional evidence is
                expected to confirm this assertion of pathogenicity
              </div>
            </div>
            {/* 18 */}
            <div
              style={{
                width: "100%",
                padding: "9px",
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
              className="marginBody"
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  textAlign: "start",
                  borderRadius: "1px 1px",
                  backgroundColor: "#dbd7d7",
                  paddingBlock: "5px",
                }}
              >
                <div style={{ width: "30%", marginLeft: 8, color: "#1A5276" }}>
                  <b> Variant of uncertain significance</b>
                </div>
                <div style={{ width: "70%", marginLeft: 24 }}>
                  A variant which is difficult to classify either as pathogenic
                  (disease causing) or benign (non-disease causing) based on
                  current available scientific evidence.
                </div>
              </div>
            </div>
            <div
              style={{
                width: "100%",
                padding: "9px",
                display: "flex",
                justifyContent: "space-between",
                gap: "20px",
              }}
              className="marginBody"
            >
            </div>

            {/* Disclaimer */}
            <div
              style={{
                width: "100%",
                display: "flex",
                margin: "10px 0px",
                color: "#1A5276",
                padding: "5px",
                borderLeft: "2px solid red",
                marginLeft: "14px"
              }}
            >
              <div
                style={{ width: "100%", marginLeft: 12 }}
                className="marginBody"
              >
                <h5>
                  <b>Disclaimer</b>
                </h5>
              </div>
            </div>
            <div className="marginBody">
              <div style={{
                width: "100%",
                display: "flex",
                margin: "10px 0px",
                textAlign: "start",
                padding: "5px",
                // marginLeft: "13px",
                marginTop: "-10px",
                fontSize: "16px"

              }}>
              </div>
              <ul style={{ marginTop: "-15px", marginLeft: "12px" }}>
                <li>Interpretation of variants in this report is performed to the best knowledge of the laboratory based on the
                  information available at the time of reporting. The classification of variants can change over time and laboratory
                  cannot be held responsible for this. Re-analysis of variants in previously issued reports in light of new evidence is not
                  routinely performed, but may be available upon request.</li>
                <li>Negative results do not completely exclude the risk/carrier status for these disorders tested (residual risk)</li>
                <li>The test methodology currently does not detect large deletions/duplications, deep intronic variants, and regulatory
                  region variants.</li>
                <li>Phenotype variability may be due to modifying genetic/non-genetic factors and is not a part of the current analysis.</li>
                <li>Variants of unknown significance may be detected and may not be reported subject to analysis by various
                  methodologies.</li>
                <li>Due to inherent technology limitations of the assay, not all bases of the genes can be covered by this test.
                  Accordingly, variants in regions of insufficient coverage may not be identified and/or interpreted. Therefore, it is
                  possible that pathogenic variants are present in one or more of the genes analyzed, but have not been detected. The
                  variants not detected by the assay that was performed may impact the phenotype.</li>
                <li>It is also possible that a pathogenic variant is present in a gene that was not selected for analysis and/or
                  interpretation in cases where insufficient phenotypic information is available.</li>
                <li>Genes with pseudogenes, paralog genes and genes with low complexity may have decreased sensitivity and
                  specificity of variant detection and interpretation due to inability of the data and analysis tools to unambiguously
                  determine the origin of the sequence data in such regions.</li>
                <li>If variants are detected, Sanger sequencing confirmation is needed.</li>
                <li>Incidental or secondary findings (if any) that meet the ACMG guidelines can be given upon request.</li>
                <li>The report shall be generated within turnaround time (TAT), however, such TAT may vary depending upon the
                  complexity of test(s) requested. Laboratory under no circumstances will be liable for any delay beyond
                  aforementioned TAT.</li>
                <li>It is hereby clarified that the report(s) generated from the test(s) do not provide any diagnosis or opinion or
                  recommends any cure in any manner. Laboratory hereby recommends the patient and/or the guardians of the
                  patients, as the case may be, to take assistance of the clinician or a certified physician or doctor, to interpret the
                  report(s) thus generated. Laboratory hereby disclaims all liability arising in connection with the report(s).</li>
                <li>In a very few cases genetic test may not show the correct results, e.g. because of the quality of the material provided
                  to laboratory. In case where any test provided by laboratory fails for unforeseeable or unknown reasons that cannot
                  be influenced by laboratory in advance, laboratory shall not be responsible for the incomplete, potentially misleading
                  or even wrong result of any testing if such could not be recognized by laboratory in advance.</li>
              </ul>
            </div>
            <div className="bodyMargin8">.</div>
            <div className="bodyMargin3">.</div>
            <div className="bodyMargin3">.</div>
            <div className="bodyMargin3">.</div>
            <div style={{ marginTop: "17px", marginLeft: "17px", padding: "3px", background: "#EEEEEE", borderRadius: "0px 10px", width: "730px", height: "30px" }}>
              <h6> Patient Name: &nbsp;
                {brcaReport[0]?.designation}&nbsp;
                {brcaReport[0]?.customer_name} &nbsp;&nbsp;&nbsp;Booking Id:&nbsp;{brcaReport[0]?.pk} </h6>
            </div>
            {/* Refernce */}
            <div
              style={{
                width: "100%",
                display: "flex",
                margin: "10px 0px",
                color: "#1A5276",
                padding: "5px",
                borderLeft: "2px solid red",
                marginLeft: "14px"
              }}
            >
              <div
                style={{ width: "100%", marginLeft: 12, }}
                className="marginBody"
              >
                <h5>
                  <b>References </b>
                </h5>
              </div>
            </div>
            <div>
              <div style={{
                width: "100%",
                display: "flex",
                textAlign: "start",
                padding: "5px",
                fontSize: "15px"
              }}>
                <ul style={{ marginLeft: "12px" }}>
                  <li>Hamosh, A., Scott, A. F., Amberger, J. S., Bocchini, C. A., &McKusick, V. A. (2005). Online Mendelian Inheritance in Man (OMIM), a
                    knowledgebase of human genes and genetic disorders. Nucleic Acids Research, 33(Database Issue), D514–D517.
                    http://doi.org/10.1093/nar/gki033, https://www.omim.org/</li>
                  <li>Landrum, M. J., Lee, J. M., Riley, G. R., Jang, W., Rubinstein, W. S., Church, D. M., &Maglott, D. R. (2014). ClinVar: public archive of
                    relationships among sequence variation and human phenotype. Nucleic Acids Research, 42(Database issue), D980–D985.
                    http://doi.org/10.1093/nar/gkt1113 https://www.ncbi.nlm.nih.gov/clinvar/</li>
                  <li>Kuchenbaecker KB, Hopper JL, Barnes DR, et al. Risks of breast, ovarian, and contralateral breast cancer for BRCA1 and BRCA2
                    mutation carriers. JAMA 2017; 317(23):2402–2416.</li>
                  <li>Antoniou A, Pharoah PDP, Narod S, et al. Average risks of breast and ovarian cancer associated with BRCA1or BRCA2 mutations detected
                    in RCL series unselected for family history: A combined analysis of 22 studies. American Journal of Human Genetics 2003; 72(5):1117–1130.</li>
                  <li>Chen S, Parmigiani G. Meta-analysis of BRCA1 and BRCA2 penetrance. Journal of Clinical Oncology 2007;25(11):1329–1333. Brose MS,
                    Rebbeck TR, Calzone KA, et al. Cancer risk estimates for BRCA1 mutation carriers identified in arisk evaluation program. Journal of the
                    National Cancer Institute 2002;94(18):1365–1372.</li>
                  <li>Finch A, Beiner M, Lubinski J, et al. Salpingo-oophorectomy and the risk of ovarian, fallopian tube, and peritoneal cancers in women with
                    a BRCA1 or BRCA2 mutation. JAMA 2006;296(2):185–192.</li>
                  <li>Levine DA, Argenta PA, Yee CJ, et al. Fallopian tube and primary peritoneal carcinomas associated with BRCAmutations. Journal of
                    Clinical Oncology 2003; 21(22):4222–4227. 7. Tai YC, Domchek S, Parmigiani G, Chen S. Breast cancer risk among male BRCA1 and BRCA2
                    mutation carriers. Journal of the NationalCancer Institute 2007; 99(23):1811–1814.</li>
                  <li>Richards, S., Aziz, N., Bale, S., Bick, D., Das, S., Gastier-Foster, J., et al On behalf of the ACMG Laboratory Quality Assurance Committee, H. L.
                    (2015). Standards and Guidelines for the Interpretation of Sequence Variants: A Joint Consensus Recommendation of the American
                    College of Medical Genetics and Genomics and the Association for Molecular Pathology. Genetics in Medicine : Official Journal of the
                    American College of Medical Genetics, 17(5), 405–424. http://doi.org/10.1038/gim.2015.30.</li>
                  <li>Sherry ST, Ward MH, Kholodov M, Baker J, Phan L, Smigielski EM, Sirotkin K. dbSNP: the NCBI database of genetic variation. Nucleic Acids
                    Res. 2001 Jan 1;29(1):308-11</li>
                </ul>
              </div>
            </div>

            {/* condions and reporting */}
            <div
              style={{
                width: "100%",
                display: "flex",
                margin: "10px 0px",
                color: "#1A5276",
                padding: "5px",
                // marginTop: "-13px",
                borderLeft: "2px solid red",
                marginLeft: "14px"
              }}
            >
              <div
                style={{ width: "100%", marginLeft: 12 }}
                className="marginBody"
              >
                <h5>
                  <b>Conditions for Reporting </b>
                </h5>
              </div>
            </div>
            <div>
              <div style={{
                width: "100%",
                display: "flex",
                // margin: "10px 0px",
                textAlign: "start",
                padding: "5px",
                // marginLeft: "-20px",
                fontSize: "16px"

              }}>
                <ol style={{ marginLeft: "12px" }}>
                  <li>It is presumed that specimen belongs to patient named or identified, such verification being carried out at the
                    point of generation of said specimen.</li>
                  <li>A test might not be performed due to following reasons:
                    <ol type="a">
                      <li>Specimen Quantity not sufficient (Inadequate collection/spillage during transit).</li>
                      <li>Specimen Quality not acceptable (Hemolysis/clotted/lipemic).</li>
                      <li>Incorrect sample type.</li>
                    </ol>
                  </li>
                  <li>In any of the above case a fresh specimen will be required for testing and reporting.</li>
                  <li>Partial representation of report is not allowed.</li>
                  <li>The reported tests are for the notification of the referring doctor, only to assist him/her in the diagnosis and
                    management of the patient.</li>
                  <li>This report is not valid for Medico Legal Purpose.</li>
                  <li>Applicable Jurisdiction will be of "Delhi" for any dispute/claim concerning the test(s) & results of the test(s).</li>
                </ol>
              </div>
            </div>
            <div className="page-footer tablecontent">
              <div style={{ width: "90%", display: 'flex', alignItems: 'center', padding: 0, margin: 0, justifyContent: 'space-around' }} className="tablecontent">
                {doctorList && doctorList?.length > 0 && doctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                  return (
                    <>
                      <img
                        alt="description of image"
                        style={{ width: "100px", height: "50px", marginLeft: "85px" }}
                        src={list?.parameter_url}
                      />
                    </>
                  )
                })}
              </div>
              <div style={{ width: "95%", display: 'flex', alignItems: 'left', marginLeft: "18px", marginTop: "-5px" }}>

                {doctorList && doctorList?.length > 0 && doctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                  return (
                    <>
                      <div
                        style={{
                          border: "none",
                          textAlign: "center",
                          minHeight: "85px",
                          width: "100%",
                          whiteSpace: "pre-line",
                        }}
                        contentEditable={true}
                        onInput={(e) => updateDoctorList(list?.id, e.currentTarget.textContent, index, "free_text", list)}
                      >
                        {list?.parameter_value}
                      </div>

                    </>
                  )
                })}
              </div>
              {/* footer area */}
              <div style={{ padding: "20px", marginTop: "-45px" }}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    background: "#fff",
                  }}
                >
                  <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                    <h3>
                      <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                    </h3>
                  </div>
                  <div style={{ width: "85%", textAlign: "left", padding: 10, marginTop: "-3px" }}>
                    <div
                      style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                    >
                      <div style={{ width: "33%", marginLeft: 8 }}>
                        <img
                          src={callIcon}
                          alt="logo"
                          style={{ width: "20px", margin: "2px" }}
                        />{" "}
                        <span style={{ color: "red" }}><b>931-126-1989</b></span>
                      </div>
                      <div style={{ width: "33%", marginLeft: 8 }}>
                        <img
                          src={maillIcon}
                          alt="logo"
                          style={{ width: "20px", margin: "2px" }}
                        />
                        <span style={{ color: "red" }}>
                          <b>genee@redcliffelabs.com</b>
                        </span>
                      </div>
                      <div style={{ width: "33%", marginLeft: "68px" }}>
                        <img
                          src={browserIcon}
                          alt="logo"
                          style={{ width: "20px", margin: "2px" }}
                        />
                        <span style={{ color: "red" }}><b>www.redcliffelabs.com</b></span>
                      </div>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        margin: "10px 0px",
                        textAlign: "left",
                      }}
                    >
                      <h5 style={{ marginLeft: "16px" }}>
                        {" "}<b>
                          Redcliffe Life Sciences Pvt. Ltd, H-31, Sector- 63, Noida, Uttar
                          Pradesh, 201301
                        </b>

                      </h5>
                    </div>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        margin: "10px 0px",
                        marginLeft: "16px",
                        textAlign: "left",
                      }}
                    >
                      <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                        {" "}
                        All Lab are subjected to clinical interpretations by
                        qualified medical professional and this report is not
                        subject to use for any medico-legal purpose.
                      </p>
                    </div>
                    <hr
                      style={{
                        backgroundColor: "red",
                        width: "100%",
                        height: "8px",
                        marginTop: "10px",
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* footer area closed */}
            </div>
            {
              uuid && <div className="hide-section-rating"><NpsRating bookingId={firstP} uuid={uuid}/></div>
            }
          </div >
        )}
      </div >
    </Grammarly>
  );
};

const mapStateToProps = (state: any) => ({
  reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
  getReportTemplateParameter,
  createNewReport,
  updateReport,
  getUpdatedCustomerReportData,
  resetBookingData,
  updateNiptDob,
  createNiptDob,
})(NbsReport);